<div class="search-box-widget">
    <xchange-search-control  [isGlobalSearchEnabled]="false" 
    [searchByIcon]="true" 
    [placeholder]="label"
    [(ngModel)]="searchValue"
    (sendValue)="onSearchTextChanged($event)"
    ></xchange-search-control>
</div>